export default {
  simulationDataIsMissing: 'Proszę wypełnić materiał i wybrać model obliczeniowy',
  errorMinLargerMax: 'min > maks',
};
